<template>
  <div class="pc-container">
    <div v-for="(item,index) in data" :key="index">
      <component :is="item.type" :data="item"></component>
    </div>
  </div>
</template>

<script>
import {jobData} from "@/data";
export default {
  name: 'JobView',
  data(){
    return {
    data:jobData
    }
  }
}
</script>
<style lang="scss" scoped></style>
